import React, { useEffect, useState } from "react";
import CommonForm from "../../components/common/CommonForm"; // Assurez-vous que le chemin est correct
import { useDispatch } from "react-redux";
import { addProduit, editProduit, getAllProduits } from "../../store/produitSlice";
import { use } from "react";

const FormProduit = ({ FormControls, formTitle, isDataEdit, setIsModalOpen, onProductUpdated }) => {

  const initialState = {
    designation: "", 
    unite: 0,
    entreStock: 0,// Quantité entrée en stock
    pcInvendu: 0,// Pourcentage d'invendu
    prix: 0,// Prix de vente de chaque portion
    tauxTVA: 1,// Taux de TVA
    prixVente: "",//Prix de vente de chaque produit : prix + prix * (tauxTVA / 100) + (prix * pcInvendu / 100)
    margeBrute: 0,// Marge Brute par portion vendu : prixVente - prix
    stockqty: 0,// Quantité en stock : stockqty + entreStock
    valStock: 0,// Valeur de stock : valStock + entreStock * prixVente
    alertstockqty: 0, // Quantité d'alerte en stock
    description: "", // Description du produit et informations supplémentaires
    categorieid: "", // ID de la catégorie du produit
    fournisseurid: "", // ID du fournisseur du produit
  }

  const [produitData, setProduitData] = useState(initialState || isDataEdit);

  const dispatch = useDispatch();

  useEffect(() => {

    if (isDataEdit !== null) {
      setProduitData({
        ...isDataEdit,
        stockqty: parseFloat(isDataEdit.stockqty || 0),
        valStock: parseFloat(isDataEdit.valStock || 0),
        valStockInitial: parseFloat(isDataEdit.valStockInitial || 0),
        prixVente: parseFloat(isDataEdit.prixVente || 0),
        margeBrute: parseFloat(isDataEdit.margeBrute || 0),
      });
    }
  }, [isDataEdit]);


  useEffect(() => {
    if (isDataEdit !== null) {      

        const entreStock = parseFloat(produitData.entreStock || 0); // Nouvelle entrée de stock
        const prix = parseFloat(produitData.prix) ? parseFloat(produitData.prix || 0) : parseFloat(isDataEdit.prix || 0); // Prix actuel
        const pcInvendu = parseFloat(produitData.pcInvendu || 0) / 100; // Pourcentage invendu
        const tauxTVA = parseFloat(produitData.tauxTVA || 1) / 100; // Taux TVA

        // Calcul de la valeur du stock actuel
        const valeurStockActuelle = parseFloat(isDataEdit.stockqty) * parseFloat(isDataEdit.prixVente);

        // Calcul de la valeur du stock actuel
        const StockActuelle = parseFloat(isDataEdit.stockqty || 0); ;

        // Calcul dynamique du prix de vente
        const nouveauPrixVente = prix + (prix * tauxTVA) + (prix * pcInvendu);

        // Nouveau stock total
        const nouveauStockTotal = StockActuelle + entreStock;

        // Si entreStock diminue ou augmente, ajuster correctement
        const valeurNouveauStock = entreStock * nouveauPrixVente;

        // Calcul de la nouvelle marge brute
        const nouvelleMargeBrute = (nouveauPrixVente -  prix) + parseFloat(isDataEdit.margeBrute || 0);

        const valStockInitial = valeurStockActuelle; // Stock initial fixé au début
        const valStock = valeurStockActuelle + valeurNouveauStock; // Valeur totale du stock
        const margeBrute = nouvelleMargeBrute; // Mise à jour de la marge brute

        setProduitData((prevData) => ({
          ...prevData,
          valStockInitial: valStockInitial, // Mettre à jour la valeur du stock initial
          stockqty: nouveauStockTotal, // Mettre à jour la quantité en stock
          valStock,
          prixVente: nouveauPrixVente,
          margeBrute,
        }));    

    } else {

      if (produitData.entreStock >= 0) {

        const stockInitial = 0; // Stock initial fixé au départ
        const valStockInitial = 0; // Stock initial fixé au départ
        const entreStock = parseFloat(produitData.entreStock || 0);
        const prix = parseFloat(produitData.prix || 1);
        const pcInvendu = parseFloat(produitData.pcInvendu || 0) / 100;
        const tauxTVA = parseFloat(produitData.tauxTVA || 1) / 100;


        // Calcul dynamique du prix de vente
        const nouveauPrixVente = prix + (prix * tauxTVA) + (prix * pcInvendu);

        // Calcul de la valeur du nouveau stock
        const valeurNouveauStock = entreStock * nouveauPrixVente;


        const prixVente = nouveauPrixVente;
        const stockqty = stockInitial + entreStock;
        const valStock = valeurNouveauStock;
        const margeBrute = nouveauPrixVente - prix;


        setProduitData((prevData) => ({
          ...prevData,
          stockInitial,
          valStockInitial,
          prixVente,
          stockqty,
          valStock,
          margeBrute,
        }));
      }
    }
  }, [isDataEdit, produitData.entreStock, produitData.prix, produitData.pcInvendu, produitData.tauxTVA,]);


  const validateForm = () => {
    if (produitData.designation === "") return "Veuillez Saisir la désignation.";
    if (produitData.unite <= 0) return "Merci de saisir le nombre de portions.";
    if (produitData.entreStock < 0) return "Veuillez saisir la quantié entrée en stock.";
    if (produitData.prix <= 0) return "Merci de saisir le prix du produit.";
    if (produitData.pcInvendu <= 0) return "Le pourcentage d'invendu doit être supérieur à zéro.";
    if (produitData.tauxTVA <= 0) return "Veuillez choisir le taux de charge de TVA.";
    if (produitData.categorieid === "") return "Veuillez choisir une categorie.";
    if (produitData.fournisseurid === "") return "Veuillez choisir le fournisseur.";
    return null;
  };

  // Soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();

    const errorMessage = validateForm();
    if (errorMessage) {
      alert(errorMessage); // Remplacez par un meilleur système de gestion des erreurs
      return;
    }

    isDataEdit ? console.log("Modification du produit", produitData) : console.log("Ajout du produit", produitData);

    if (isDataEdit) {
      //console.log("Modification du produit", produitData);

      dispatch(
        editProduit({
          id: isDataEdit.id, // Assurez-vous qu'isDataEdit n'est pas null ici
          produitData,
        })
      ).then((data) => {
        if (data?.payload?.success) {
          dispatch(getAllProduits());
          setProduitData({});
          setIsModalOpen(false); // Ferme le modal après la soumission
          const updatedProduct = data?.payload?.data;
          onProductUpdated && onProductUpdated(updatedProduct);
        }
      });
    } else {
      //console.log("Ajout du produit", produitData);

      dispatch(
        addProduit(produitData)
      ).then((data) => {
        if (data?.payload?.success) {
          dispatch(getAllProduits());
          setProduitData(initialState);
          setIsModalOpen(false); // Ferme le modal après la soumission
        }
      });
    }

    setIsModalOpen(false);

    //console.log("Données du produit :", produitData);
  };


  function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }


  return (
    <div className="p-4">
      <table className="mb-3 w-full">
        <tr>
          <td>S.I : {formatPrice((Number(produitData.stockInitial) || 0).toFixed(2))} |</td>
          <td>Q.S : {formatPrice(produitData.stockqty.toFixed(2))} |</td>
          <td>V.S : {formatPrice(produitData.valStock.toFixed(2))} |</td>
          <td className={` ${produitData.prixVente < 0 ? "text-red-500" : "text-green-700"}`}>
            P.V : {formatPrice((Number(produitData.prixVente) || 0).toFixed(2))}
          </td>
          <td className={` ${produitData.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>M.B : {produitData.margeBrute.toFixed(2)}</td>
        </tr>
      </table>
      <CommonForm
        formControls={FormControls}
        formData={produitData}
        formTitle={formTitle}
        setFormData={setProduitData}
        handleSubmit={handleSubmit}
        ButtonText="Soumettre"
      />
    </div>
  );
};

export default FormProduit;
